import { lazy } from 'react';

// Pages chargées à la demande (code splitting) avec préchargement possible au survol.
const registry = {};

export const lazyPage = (path, importer) => {
  let promise = null;
  const preload = () => { if (!promise) promise = importer(); return promise; };
  const C = lazy(preload);
  C.preload = preload;
  if (path) registry[path] = preload;
  return C;
};

// Précharge le code d'une route (ex: au survol d'un lien du menu).
export const preloadRoute = (path) => {
  const fn = registry[path] || registry[Object.keys(registry).find(k => k !== '/' && path?.startsWith(k))];
  if (fn) { try { fn(); } catch { /* ignore */ } }
};
